import { Navigate, useLocation } from 'react-router-dom'

type StudioRouteRedirectProps = {
  to: string
}

export default function StudioRouteRedirect({ to }: StudioRouteRedirectProps) {
  const location = useLocation()

  return (
    <Navigate
      to={{
        pathname: to,
        search: location.search,
        hash: location.hash,
      }}
      replace
    />
  )
}
